import colorLegend from "./Modules/colorLegend";

export default class Legend {
  constructor({ main }) {
    this._ = main;
    this.colorLegend = colorLegend;
    this.defaults = this._.settings.get("colorScales");
  }

  createSwatchesLegend(title, data) {
    const swatchesLegend = document.createElement("div");
    const swatches = data.map(([partyName, color]) => {
      return `<div class="swatch-item">
                  <div class="swatch-color" style="background:${color}"></div>
                  <div class="swatch-name">${partyName}</div>
                </div>`;
    });
    const swatchesWrapper = document.createElement("div");
    swatchesWrapper.classList.add("swatch-legend");
    swatchesWrapper.innerHTML = `${swatches.join("")}`;
    const titleContainer = `<div class="legend-title">${title}</div>`;
    swatchesLegend.innerHTML = titleContainer;
    swatchesLegend.appendChild(swatchesWrapper);
    let selector = ".legend-mobile";
    if (this._.sizes.isDesktop) {
      selector = ".legend-desktop";
    }

    Array.from(this._.el.querySelectorAll(`.legend${selector}`))
      .reverse()
      .forEach((el) => {
        el.replaceChildren(swatchesLegend.cloneNode(true));
        el.style.opacity = 1;
      });
  }

  createCategoryLegend(variable, currentConfig, data) {
    const { title, subTitle, units } = currentConfig;
    if (
      Array.isArray(currentConfig.swatches) &&
      currentConfig.swatches.length > 0 &&
      data === undefined // it doesn't come from 'mouseover'
    ) {
      this.createSwatchesLegend(title, currentConfig.swatches);
    } else if (
      currentConfig.needsUpdate === true &&
      data !== undefined &&
      this._.colorScales[variable][data.cat] !== undefined
    ) {
      const scale = this._.colorScales[variable][data.cat];
      this.createScaleLegend({
        scale,
        legendTitle: `${title} (${data.cat})`,
        legendSubTitle: subTitle,
        units: units,
      });
    } else {
      const scale = this._.colorScales[variable]["otros"];
      this.createScaleLegend({
        scale,
        legendTitle: title,
        legendSubTitle: subTitle,
        units: units,
      });
    }
  }

  updateLegend(variable, isNative, update, tickValues) {
    const scale =
      this._.colorScales.getColorScale(variable) ||
      this._.colorScales.getColorScale("default");

    if (tickValues === undefined) {
      const scalesSettings = this._.settings.get("modules").colorScales;
      const scaleSettings = scalesSettings[variable];
      if (
        scaleSettings !== undefined &&
        scaleSettings.tickValues !== undefined
      ) {
        tickValues = scaleSettings.tickValues;
      }
    }

    const currentConfig =
      this._.colorScales.config[variable] ||
      this._.colorScales.config["default"];
    const { title, subTitle, units } = currentConfig;
    const needsUpdate = currentConfig.needsUpdate;

    if (currentConfig !== undefined) {
      if (needsUpdate === false && isNative === true) {
      } else if (needsUpdate === true) {
        this.createCategoryLegend(variable, currentConfig, update);
      } else {
        this.createScaleLegend({
          scale,
          legendTitle: title,
          legendSubTitle: subTitle,
          units: units,
          tickValues: tickValues,
        });
      }
    } else {
      console.error(`Variable ${variable} is not in 'modules.colorScales'`);
    }
  }

  createScaleLegend({ scale, legendTitle, legendSubTitle, tickValues, units }) {
    const locate = "pt"; // codificacion de los numeros
    const _height = 25; // Altura del SVG franja <svg height>
    const _tickSize = 2; // Altura franja de color <image height> a ( > tick < height)
    const _marginTop = 2; // posicion <image y>
    const _marginBottom = 14; // Altura franja de color <image height> a (< marginBottom > height)
    const _squareHeight = 5; // altura de los rectángulos de la leyenda
    const _padding = 20 * 2; // Horizontal franja <svg width> a (> padding < width)
    const el = this._.el; // leyenda box
    this._.el.querySelectorAll(".legend").forEach((legend) => {
      legend.innerHTML = "";
    });

    // Formateo de los valores dependiendo la localizacion y decimales
    const tickFormat = function (n, i) {
      const suffix = units !== undefined ? units : "";
      let ret = n.toLocaleString(locate);
      if (i === 0) {
        ret = `${n.toLocaleString(locate)} ${suffix}`;
      }

      return ret;
    };

    let selector = ".legend-mobile";
    let widthLegend = this._.el
      .querySelector(".legend-mobile")
      .getBoundingClientRect().width;

    if (this._.sizes.isDesktop) {
      widthLegend = this._.el
        .querySelector(".legend-desktop")
        .getBoundingClientRect().width;

      selector = ".legend-desktop";
    }
    if (widthLegend === 0) return;
    Array.from(this._.el.querySelectorAll(`.legend${selector}`))
      .reverse()
      .forEach((el) => {
        const title = document.createElement("div");
        title.classList.add("legend-title");
        title.innerHTML = legendTitle;

        el.appendChild(title);
        el.appendChild(
          colorLegend(scale, {
            titleAnchor: this._.sizes.isDesktop ? "start" : "end",
            width: widthLegend - _padding,
            squareHeight: _squareHeight,
            tickFormat,
            tickValues: tickValues || scale.domain(),
            height: _height,
            tickSize: _tickSize,
            marginTop: _marginTop,
            marginBottom: _marginBottom + _tickSize,
          })
        );
        if (legendSubTitle !== undefined) {
          const subTitle = document.createElement("div");

          subTitle.classList.add("legend-subtitle");
          subTitle.innerHTML = legendSubTitle;
          el.appendChild(subTitle);
        }
        el.style.opacity = 1;
      });

    if (this._.el.querySelector(`.legend${selector}`)) {
      this._.el
        .querySelector(`.legend${selector}`)
        .classList.remove("swatch-legend");
      this._.el.querySelector(`.legend${selector}`).classList.add("active");
    }
  }
}
